import React, { useMemo } from "react";
import { generateColumns } from "../utils/columns";
import config from "../config";
import { useTable, usePagination } from "react-table";
import { TableContainer, Table as MUITable } from "@material-ui/core";
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import TableFooter from "./TableFooter";

function Table({data, state, setState, constants}) {
    const columns = useMemo(() => generateColumns(constants), [constants]);
    const articlesPerPage = config.articlesPerPage;
    const articleCount = data.articleCount;

    const instance = useTable(
        {
            columns,
            data: data.articles,
            initialState: { pageIndex: 0, pageSize: articlesPerPage },
            manualPagination: true,
            pageCount: Math.ceil(articleCount / articlesPerPage),
        },
        usePagination
    );

    const {
        getTableProps,
    } = instance;

    return(
        <TableContainer>
            <MUITable {...getTableProps()}>
                <TableHead instance={instance} />
                <TableBody instance={instance} />
                <TableFooter articlesPerPage={articlesPerPage} articleCount={articleCount} state={state} setState={setState} />
            </MUITable>
        </TableContainer>
    );
}

export default Table;
